export default "__VITE_ASSET__XFFoKrdV__"